/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: CoursesPage.css.ts
*/

import styled from 'styled-components';
import { breakpoint } from '../../../styles/breakpoints';

export const PageSection = styled.section<{
  colorDay: string;
  colorNight: string;
  isLightsOn: boolean;
}>`
  background: ${(props) => (props.isLightsOn ? props.colorDay : props.colorNight)};
  display: flex;
  flex-direction: row;

  height: 115em;
  padding-left: 5em;
  margin-top: -8em;

  ${breakpoint('tablet')`
    flex-direction: column;
    height: 125em;
  `}
  ${breakpoint('mobile')`
    height: 135em;
    padding-left: 2.5em;
  `}
`;

export const Column = styled.div`
  padding: 0em 2em 2em 2em;
`;

export const Row = styled.div`
  display: flex;
  padding-bottom: 3em;
  ${breakpoint('mobile')`
    padding-bottom: 1em;
  `}
`;

export const Title = styled.p`
  ${(props) => props.theme.typography.typeStyleRevxNeueText3}
  color: ${(props) => props.theme.colors.black};
  position: relative;
  height: 1em;
  weight: 100%;
`;

export const Content = styled.div`
  ${(props) => props.theme.typography.typeStyleRevxNeueText1}
  width: 80vw;
`;
